import { isDateFromDataInISOFormat } from "components/Utils/Utils";
import React from "react";
import MixChannelAnalysis from "./MixChannelAnalysis";

const transformData = (data) => {
  return data.map((entry) => {
    const transformedEntry = {};
    Object.keys(entry).forEach((key) => {
      const newKey = key.replace(/[ |]/g, "_"); // Replace spaces and '|' with '_'
      let value = entry[key];

      // Format numbers as strings with only two decimal places
      if (typeof value === "number") {
        value = value.toFixed(2);
      }

      // Convert date strings to ISO format
      if (key.toLowerCase() === "date") {
        const dateObj = new Date(value);
        value = dateObj.toISOString().split("T")[0]; // Keep only the date part
      }

      transformedEntry[newKey] = value;
    });
    return transformedEntry;
  });
};

const MMMChannelAnalysisWidget = ({ childRef, data }) => {
  const getExportData = (data) => {
    childRef({
      getExportData: () => {
        return {
          data: transformData(data),
          opts: {
            date: {
              // overwrites the default settings for date only when the date is in ISO format
              defined: isDateFromDataInISOFormat(data),
              format: "YYYY-MM-DDThh:mm:ssZ",
              viewFormat: "YYYY-MM-DD",
            },
          },
        };
      },
    });
  };

  return (
    <MixChannelAnalysis
      showSlider={false}
      isUsingOnMix={false}
      channelData={data}
      getExportData={getExportData}
    />
  );
};

export default MMMChannelAnalysisWidget;
